import {
  PlanLineTO,
  ProductSummaryTO,
  ResourceLineTO,
  SelectedOptionsTO,
  SubsDataResponse,
} from './types';

export function checkResellerOnly(
  existingCartData: any,
  selectedOption: SelectedOptionsTO[],
  cartSummary: any
) {
  let result = false;

  //1. check if any reselleronly exists in current plans
  if (selectedOption?.some((innerPTR) => innerPTR?.option?.resellerOnly)) {
    if (existingCartData?.data?.isEndUserSelected) {
      result = true;
    } else if (
      cartSummary?.data?.planLine?.some(
        (ptr: PlanLineTO) => !ptr.isResellerOnly
      )
    ) {
      result = true;
    }
  }
  if (selectedOption?.some((innerPTR) => !innerPTR?.option?.resellerOnly)) {
    if (
      cartSummary?.data?.planLine?.some((ptr: PlanLineTO) => ptr.isResellerOnly)
    ) {
      result = true;
    }
  }
  return result;
}

export function getExistingDependents(
  selectedOption: SelectedOptionsTO[],
  existingCartData: any,
  subOptions?: SubsDataResponse
) {
  let result = '';
  const dictionary = new Map<string, string[]>();
  if (
    selectedOption &&
    selectedOption.length > 0 &&
    subOptions?.data?.subOptions
  ) {
    selectedOption.forEach((cartItem) => {
      //1. Check if depnds on exists.
      const found = subOptions?.data?.subOptions?.find(
        (innerPTR: ProductSummaryTO) =>
          innerPTR?.subscriptionOption?.resourceApsId ===
            cartItem?.option?.resourceApsId &&
          innerPTR?.subscriptionOption?.dependson !== null &&
          innerPTR?.subscriptionOption?.dependson !== undefined
      );
      //2. check if dependent exists in cart
      if (found != null && found !== undefined) {
        found?.subscriptionOption?.dependson.forEach((dependent: any) => {
          const dependentRef = dependent.resource as string;
          existingCartData?.data?.planLine?.forEach((innerPTR: PlanLineTO) => {
            if (innerPTR.planId === dependentRef) {
              if (!dictionary.has(cartItem?.option?.resourceApsId)) {
                dictionary.set(cartItem.option.resourceApsId, [dependentRef]);
              } else {
                const returnArray = dictionary.get(
                  cartItem.option.resourceApsId
                ) as string[];
                if (!returnArray.includes(dependentRef)) {
                  returnArray.push(dependentRef);
                  dictionary.set(cartItem?.option?.resourceApsId, returnArray);
                }
              }
            } else if (
              innerPTR.resourceLine?.some(function (el: ResourceLineTO) {
                return el.resourceId === dependentRef;
              })
            ) {
              if (!dictionary.has(cartItem.option.resourceApsId)) {
                dictionary.set(cartItem.option.resourceApsId, [dependentRef]);
              } else {
                const returnArray = dictionary.get(
                  cartItem.option.resourceApsId
                ) as string[];
                if (!returnArray.includes(dependentRef)) {
                  returnArray.push(dependentRef);
                  dictionary.set(cartItem.option.resourceApsId, returnArray);
                }
              }
            }
          });
        });
      }
    });
  }
  let optionA = '';
  let optionB = '';
  dictionary.forEach(function (value, key) {
    optionA =
      subOptions?.data?.subOptions?.find(
        (innerPTR) => innerPTR?.subscriptionOption?.resourceApsId === key
      )?.subscriptionOption?.title ?? '';
    const container = dictionary.get(key);
    container?.forEach((innerPTR) => {
      optionB =
        subOptions?.data?.subOptions?.find(
          (ptr) => ptr?.subscriptionOption?.resourceApsId === innerPTR
        )?.subscriptionOption?.title ?? '';
      result += `Option A ${optionA} & Option B ${optionB} cannot be combined in your shopping cart. Please remove Option A  before you can add Option B.\n`;
    });
  });

  return { option1: optionA, option2: optionB, result: result };
}

export default function ValidateMinMaxQuantity(
  qtyToCompare: number,
  maxQty: number,
  minQty: number
) {
  if (qtyToCompare === 999999999) return 'InValid';

  //for option with min qty of 1, and NO max qty
  if (maxQty === 999999999 && minQty === 1 && qtyToCompare < minQty) {
    return `Minimum quantity allowed: 1`;
  }
  //for option with max qty of 5000, and NO min qty
  if (
    (minQty === undefined || minQty === 0) &&
    maxQty !== 99999999 &&
    qtyToCompare > maxQty
  ) {
    return `Maximum quantity allowed: ${maxQty}`;
  }

  if (
    maxQty !== undefined &&
    maxQty > 0 &&
    maxQty !== 99999999 &&
    ((minQty !== undefined && qtyToCompare < minQty) ||
      (maxQty !== undefined && qtyToCompare > maxQty))
  ) {
    return `Quantity allowed: ${minQty} to ${maxQty}`;
  }
  return '';
}
